export default {
    "搜索问题关键词":"Search for keywords",
    "常见问题":"Common Questions",
    "已解决":"Resolved",
    "未解决":"Unresolved",
    "更多问题，可以点开小游戏右上角三个点，选择问题与反馈进行提交":"For more questions, you can click on the three dots in the upper right corner of the game, select \"Submit Questions and Feedback\"",
    "其他相关问题":"Other related questions",
    "暂无相关问题":"No related questions at the moment",
    "是否需要反馈问题?":"Do you need to provide feedback on questions?",
    "更多问题，可以点击\"问题反馈\"进行提交":"For more questions, you can click on \"Submit Feedback\"",
    "确定":"confirm",
    "取消":"cancel",
    "问题反馈":"Problem Feedback",
    "中文":"en",
}


// WEBPACK FOOTER //
// ./src/vuex/i18n/en_i18n.js